var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 127,
    viewBox: "0 0 117 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 114.8L112 61.2996L58.5 7.79956L5 61.2996L58.5 114.8Z",
    fill: "#0B8133",
    stroke: "#12D253"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2913 44.6667H80.7063L58.5 62.6637L36.2913 44.6667Z",
    fill: "#12D253"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9537 58.501L35.1667 71.829V49.7603L45.9537 58.501Z",
    fill: "#12D253"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5773 61.4387L58.5 68.6697L67.4367 61.427L80.5313 77.3333H36.7137L49.5773 61.4387Z",
    fill: "#12D253"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0627 58.4893L81.8333 49.7603V71.5723L71.0627 58.4893Z",
    fill: "#12D253"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBack);
export default __webpack_public_path__ + "static/media/email-back.b36cea830bf85b5a06e32d7c0f03bcbc.svg";
export { ForwardRef as ReactComponent };